import {  superdernekConfig } from "./tenants/superdernek.config";
import { defaultConfig } from "./tenants/default.config";
import { derneksistemConfig } from "./tenants/derneksistem.config";


export const detectTenant = () => {
    if (typeof window === "undefined") {
        return defaultConfig.tenantId;
    }

    const hostname = window.location.hostname;

    // SuperDernek domainleri
    if (
        hostname.includes("superdernek.com")
    ) {
        return "superdernek";
    }

    // DernekSistem domainleri
    if (
        hostname.includes("derneksistem.com")
    ) {
        return "derneksistem";
    }

    // Localhost ve diğer durumlar için superdernek kullan
    return "superdernek";
};


export const getTenantConfig = (tenantId) => {
    const tenant = tenantId || detectTenant();

    switch (tenant) {
        case "superdernek":
            return superdernekConfig;
        case "derneksistem":
            return derneksistemConfig;
        default:
            return superdernekConfig;
    }
};

export const getCurrentTenant = () => {
    return getTenantConfig();
};

export const getCurrentDomainTitle = () => {
    if (typeof window === "undefined") {
        return null;
    }

    const hostname = window.location.hostname;

    // SuperDernek domainleri

    if (hostname.includes("superdernek.com")) {
        return "superdernek.com";
    }

    // DernekSistem domainleri

    if (hostname.includes("derneksistem.com")) {
        return "derneksistem.com";
    }

    // Localhost veya bilinmeyen domain
    return hostname;
};



export const getCurrentHostname = () => {
    if (typeof window === "undefined") {
        return null;
    }
    return window.location.origin;
};



